import apiClient from '../../../services/apiClient';

const dashboardService = {
  // Get dashboard statistics
  getDashboardStats: async () => {
    console.log('📊 Dashboard Service: Fetching dashboard statistics');
    
    try {
      const response = await apiClient.get('/dashboard/stats');
      console.log('✅ Dashboard Service: Statistics received:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Dashboard Service: Error fetching dashboard stats:', error);
      
      // Return fallback data if API fails
      console.log('📝 Dashboard Service: Using fallback data');
      return {
        total_bookings: 0,
        clinical_telehealth_bookings: 0,
        general_telehealth_bookings: 0,
        total_users: 0,
        new_users_15_days: 0,
        new_doctors_15_days: 0,
        new_clinicians_15_days: 0
      };
    }
  },

  // Get monthly chart data
  getMonthlyChartData: async () => {
    console.log('📊 Dashboard Service: Fetching monthly chart data');
    
    try {
      const response = await apiClient.get('/dashboard/chart-data/monthly');
      console.log('✅ Dashboard Service: Monthly chart data received:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Dashboard Service: Error fetching monthly chart data:', error);
      return [];
    }
  },

  // Get daily chart data
  getDailyChartData: async () => {
    console.log('📊 Dashboard Service: Fetching daily chart data');
    
    try {
      const response = await apiClient.get('/dashboard/chart-data/daily');
      console.log('✅ Dashboard Service: Daily chart data received:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Dashboard Service: Error fetching daily chart data:', error);
      return [];
    }
  }
};

export default dashboardService;








